import Icon from '../components/Icon.vue'

Icon.register({"star":{"width":576,"height":512,"paths":[{"d":"M259.3 17.8L194 150.2 47.9 171.5C21.7 175.3 11.2 207.6 30.2 226.1L135.9 329.1 110.9 474.6C106.4 500.9 134.1 520.6 157.3 508.3L288 439.6 418.7 508.3C441.9 520.5 469.6 500.9 465.1 474.6L440.1 329.1 545.8 226.1C564.8 207.6 554.3 175.3 528.1 171.5L382 150.2 316.7 17.8C305-5.8 271.1-6.1 259.3 17.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star.js
// module id = nfyY
// module chunks = 0